import { v4 } from 'uuid'

class UploadConstraintValidator {
  globalConstraints = ['maxFiles', 'minFiles']
  constraints: Upload.DirectorConstraints
  isMultiple: boolean
  files: Upload.DirectorFile[]
  store: Upload.DirectorFile[]

  public constructor(config: Upload.DirectorConfig, files: Upload.DirectorFile[], store: Upload.DirectorFile[]) {
    this.constraints = config.constraints
    this.isMultiple = config.allowMultiple
    this.files = files
    this.store = store
  }

  public validate() {
    const constraints = Object.keys(this.constraints).filter(
      (constraint) => !this.globalConstraints.includes(constraint)
    )
    let files: Upload.DirectorFile[] = []
    let errors: Upload.DirectorConstraintError[] = []

    if (this.constraints && this.files) {
      try {
        if (this.isMultiple && this.constraints.maxFiles) {
          this.validateConstraint('maxFiles')
        }

        if (this.constraints.minFiles) {
          this.validateConstraint('minFiles')
        }

        files = this.files.filter((file) => {
          try {
            constraints.map((constraint) => this.validateConstraint(constraint, file))
          } catch (error) {
            errors.push(error)

            return false
          }

          return true
        })
      } catch (error) {
        errors.push(error)
      }
    }

    return {
      files,
      errors,
    }
  }

  private validateConstraint(constraint: string, file?: Upload.DirectorFile) {
    let result

    switch (constraint) {
      case 'minFiles':
        result = this.minFiles()
        break
      case 'maxFiles':
        result = this.maxFiles()
        break
      case 'maxFileSize':
        result = this.maxFileSize(file)
        break
      case 'allowedMimeTypes':
        result = this.allowedMimeTypes(file)
        break
    }

    if (result === false) {
      throw {
        id: v4(),
        constraint,
        fileName: file?.name || null,
      }
    }
  }

  private minFiles(): boolean {
    return this.constraints.minFiles <= this.store.length + this.files.length
  }

  private maxFiles(): boolean {
    return this.constraints.maxFiles >= this.store.length + this.files.length
  }

  private maxFileSize(file: Upload.DirectorFile): boolean {
    return file.data.size <= this.constraints.maxFileSize
  }

  private allowedMimeTypes(file: Upload.DirectorFile): boolean {
    return this.constraints.allowedMimeTypes.includes(file.type)
  }
}

export default UploadConstraintValidator
